import React from 'react';

/**
 * Simple reusable Card component for wrapping content.
 * REMOVED overflow-hidden to prevent cropping of absolutely positioned children like dropdowns.
 */
function Card({ children, className = '', onClick, ...rest }) {
  return (
    <div
      className={`bg-white shadow-md rounded-lg ${className}`}
      onClick={onClick} // Apply the onClick handler
      {...rest} // Apply any other passed props (like style, id, etc.)
    >
      {children}
    </div>
  );
}

export default Card;